// extracted by extract-css-chunks-webpack-plugin
module.exports = {"desktop":"_110RWF","mobile":"_32i_CQ"};